import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { RegularPayments, Scales } from '../_models/payments';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { debounceTime, map } from 'rxjs/operators';
import { TariffService } from '../services/tariff.service';
import { Subscription } from 'rxjs';
import { RegularPaymentsService } from '../services/regular-payments.service';
import { MatDialog } from '@angular/material';
import { DeleteDialogComponent } from '@app/driver-tariffs/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-scales',
  templateUrl: './scales.component.html',
  styleUrls: ['./scales.component.scss']
})
export class ScalesComponent implements OnInit, OnDestroy {
  scalesForm: FormGroup;
  scalesFormArray: FormArray;
  selectedRegPayment: RegularPayments;

  scalesData: Scales[];

  private clearFormSubs: Subscription;
  private saveEventSubs: Subscription;
  private eventAfterResSubs: Subscription;

  constructor(
    private fb: FormBuilder,
    private tariffService: TariffService,
    private regularPaymentService: RegularPaymentsService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.clearFormSubs = this.tariffService.clearFormEvent.subscribe(isClear => {
      this.clearScalesFormArray();
      this.buildScalesFormArray(this.selectedRegPayment && this.selectedRegPayment.scales);
    });
    this.scalesFormArray = this.fb.array([this.initScalesFormControls()]);
    this.initScalesForm();
    this.scalesForm.valueChanges
      .pipe(
        debounceTime(100),
        map((formsValues: any) => formsValues.scales)
      )
      .subscribe(scalesValues => {
        this.tariffService.switchOverInputs(this.scalesFormArray);
        this.regularPaymentService.validationScalesSate.next(this.scalesForm.get('scales').valid);
        this.scalesData = this.scalesForm.getRawValue()['scales'];
      });
    this.regularPaymentService.validationScalesSate.next(this.scalesForm.get('scales').valid);
    this.saveEventSubs = this.regularPaymentService.saveScalesEvent.subscribe(source => {
      const reqData = this.scalesData.map(el => {
        if (el.id) {
          delete el.regular_payment_id;
          return el;
        } else {
          delete el.id;
          if (this.selectedRegPayment) {
            el.regular_payment_id = this.selectedRegPayment.id;
          }
          return el;
        }
      });
      !this.scalesForm.get('scales').pristine && this.regularPaymentService.saveScales(reqData);
    });
    this.eventAfterResSubs = this.regularPaymentService.scalesAfterResponce.subscribe(res =>
      this.tariffService.loadTariffs()
    );
  }

  @Input('selectedPayment')
  set selectedPayment(selectedPayment) {
    this.selectedRegPayment = selectedPayment;
    this.clearScalesFormArray();
    this.buildScalesFormArray(selectedPayment && selectedPayment.scales);
  }

  private initScalesForm() {
    this.scalesForm = this.fb.group({
      scales: this.scalesFormArray
    });
  }

  private initScalesFormControls(el?: Scales) {
    return this.fb.group({
      is_enabled: {
        value: el && el.is_enabled ? el.is_enabled : false,
        disabled: (this.selectedRegPayment && !this.selectedRegPayment.id) || !this.selectedRegPayment
      },
      requests_quantity: [
        el && el.requests_quantity ? el.requests_quantity : 0,
        Validators.compose([Validators.required, Validators.min(0)])
      ],
      value: [el && el.value ? el.value : 0, Validators.compose([Validators.required, Validators.min(0)])],
      id: el && el.id ? el.id : null,
      regular_payment_id: el && el.regular_payment_id ? el.regular_payment_id : null
    });
  }

  private buildScalesFormArray(data: Scales[]) {
    if (data && this.scalesFormArray) {
      data.forEach((el, i) => {
        this.scalesFormArray.setControl(i, this.initScalesFormControls(el));
      });
    }
  }

  private clearScalesFormArray() {
    if (this.scalesFormArray) {
      this.scalesFormArray.controls = [];
      this.scalesFormArray.setControl(0, this.initScalesFormControls());
    }
  }

  addNewScale() {
    this.scalesFormArray.push(this.initScalesFormControls());
  }

  onRemoveScales(index) {
    const scalesId = this.scalesFormArray.getRawValue()[index].id;
    if (scalesId) {
      this.dialog
        .open(DeleteDialogComponent, {
          data: {
            message: 'PAYMENT_REMOVE_MSG'
          }
        })
        .afterClosed()
        .subscribe(res => {
          if (res) {
            this.removeScalesInit(scalesId, index);
          }
        });
    } else {
      this.scalesFormArray.removeAt(index);
    }
  }

  private removeScalesInit(id: string, index: number) {
    this.regularPaymentService.removeScale(id).subscribe((isRemove: boolean) => {
      if (isRemove) {
        this.scalesFormArray.removeAt(index);
      }
      this.tariffService.loadTariffs();
    });
  }
  ngOnDestroy() {
    this.clearFormSubs.unsubscribe();
    this.saveEventSubs.unsubscribe();
    this.eventAfterResSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/scales/scales.component.ts